'use strict'

angular.module 'App', [
	'color.picker'

	'ngAnimate'
	'ngTagsInput'
	'ngTouch'
	'ngSanitize'

	'angular-md5'
	'angucomplete-alt'
	'angular-click-outside'
	'angular.filter'
	'currencyFilter'
	'LocalStorageModule'
	'pascalprecht.translate'
	'ngclipboard'

	'ui.bootstrap'
	'ui.bootstrap.tooltip'
	'ui.bootstrap.modal'
	'ui.validate'
	'ui.router'
	'rzSlider'

	# /assets/js/configuration.js
	'App.Constant.Configuration',
	'App.Constant.Common'
	# /assets/js/back-end-enum.js
	'App.Constant.Enum.Backend',

	'App.Component'
	'App.Directive'
	'App.Filter'
	'App.Service'
	'App.Repository'
	'App.Value'
	'App.Module'
	'App.Templates'
]

.config ($translateProvider) ->
	for lang, translationData of translations
		$translateProvider.translations(lang, translationData)

	$translateProvider
		.useSanitizeValueStrategy 'sce'
		.preferredLanguage 'en'
		.fallbackLanguage 'en'

.config ($sceDelegateProvider, CDN_URL) ->
	$sceDelegateProvider.resourceUrlWhitelist [
			'self'
			CDN_URL
	]
	return

.config ($uibTooltipProvider) ->
	$uibTooltipProvider.options
		popupDelay: 1000
		appendToBody: true

.config ($uibModalProvider) ->
	$uibModalProvider.options.size = 'lg'

.config ($locationProvider) ->
		$locationProvider
			.html5Mode true
			.hashPrefix '!'

# @see https://stackoverflow.com/a/50555609/1346234
.config ($provide) ->
	$provide.decorator '$exceptionHandler', ($delegate) ->
		return (exception, cause) ->
			message = exception.toString().toLowerCase()
			needle = 'Possibly unhandled rejection'.toLowerCase()
			ignoredCauses = [
				'canceled'
				'backdrop click'
			]
			exceptionData = message.split(/(?:: )/i)

			if message.includes(needle) || ignoredCauses.includes(exceptionData?[1]) || exceptionData?[1].includes('{')
				return

			$delegate(exception, cause)

.config ($urlRouterProvider) ->
		$urlRouterProvider.otherwise ($injector) ->
			$state = $injector.get('$state')
			$state.go('login')

.config (tagsInputConfigProvider) ->
	commonDefaults =
		displayProperty: 'name'
		minLength: 1

	tagsDefaults =
		addFromAutocompleteOnly: true
		replaceSpacesWithDashes: false

	autoCompleteDefaults =
		debounceDelay: 400

	tagsInputConfigProvider.setDefaults('tagsInput', angular.extend(commonDefaults, tagsDefaults))
	tagsInputConfigProvider.setDefaults('autoComplete', angular.extend(commonDefaults, autoCompleteDefaults))

	return

.run ($rootScope, AuthenticationService) ->
	AuthenticationService.onInit()

	$rootScope.ignoreLoader = false

.run ($rootScope, localStorageService, $window, parseBool) ->
	url = new URL($window.location)
	debugMode = url.searchParams.get('debug')

	if debugMode?
		localStorageService.set('__automatic_tests', parseBool(debugMode))

	$rootScope.__automatic_tests = localStorageService.get('__automatic_tests') == true

###
This is intended for users that just leaves browser open "forever"

After 10 minutes of inactivity (mouse not moved) check server for version.
If it does not match with current one - refresh page
###
.run (
	$interval,
	$timeout,
	$http,
	$rootScope,
	$window,
	MessageTerminal,
	UserInformation,
	ENV,
) ->
	$rootScope.version = null
	$rootScope.ENV = ENV

	versionChecker = null
	mouseTimeout = null # Debounce for mouse event

	checkVersion = =>
		$rootScope.ignoreLoader = true
		$http
			.get '/version'
			.then (response) =>
				newVersion = response.data
				$rootScope.version = newVersion if !$rootScope.version?

				if newVersion != $rootScope.version
					console.warn 'Newer version detected - reloading page'
					$window.location.reload()
					$interval.cancel versionChecker
			.finally =>
				$rootScope.ignoreLoader = false

	checkVersionPeriodically = =>
		$interval.cancel versionChecker
		versionChecker = $interval(checkVersion, 1000 * 60 * 10)

	checkVersion()
	checkVersionPeriodically()

	angular
		.element document
		.on 'mousemove', =>
			$timeout.cancel mouseTimeout

			mouseTimeout = $timeout(checkVersionPeriodically, 100)

.run (
	$transitions,
	RejectionTypes,
	$state,
	$filter,
	$rootScope,
	ConfigurationService,
	ToastService,
	UserInformation,
	AuthenticationService,
	MessageTerminal,
	searchItems
) ->
	# On state change check if we are still in same state, just different ID. If not - clear found items to be re-loaded
	# If you change state to some inner view, but you wish to keep same page search items, add data.parentStateName
	# to states that will be share same items
	$transitions.onEnter {}, (transition) =>
		getStateName = (state) =>
			if angular.isDefined(state.data) and angular.isDefined(state.data.parentStateName)
				return state.data.parentStateName
			return state.name

		if getStateName(transition.from()) != getStateName(transition.to())
			searchItems.items = []

	$transitions.onError {},
		(transition) =>
			if not [RejectionTypes.ERROR, RejectionTypes.INVALID].includes(transition.error().type)
				return

			toState = transition.to()
			console.error(transition.error().message, transition.error())

			translate = $filter('translate')
			status = '' + transition.error().detail?.status

			if status == '401' && transition.error().details?.data?.error_key == 'access_denied'
				return

			ToastService.add(
				translate('error.message'),
				translate('wbo.toast.error.heading'),
				translate('general.page.error.' + (if status == '401' then 'not_authorized' else 'not_found')),
				'error'
			)

			if status == '401'
				$state.go 'logout'
			else
				$state.go(toState.name, {id: ''}) if angular.isDefined(transition.params().id) and transition.params().id != ''

	$transitions.onStart {}, (transition) =>
		toState = transition.to()
		toState.data ?= {}

		fromName = transition.from().name

		if !fromName
			fromName = 'N/A'

		if $rootScope.__automatic_tests
			console.debug("Entering state #{fromName} -> #{toState.name}", transition.targetState().params())

		$rootScope.hideMenu = toState.data.hideMenu ? false
		$rootScope.hideSubMenu = toState.data.hideSubMenu ? false
		$rootScope.showFooter = toState.data.showFooter ? true

		isLoggedIn = AuthenticationService.isLoggedIn()

		if !isLoggedIn && (angular.isUndefined(toState.data.require_login) || toState.data.require_login)
			newState = 'login'
			$rootScope.hideMenu = true
			$rootScope.hideSubMenu = true
			$rootScope.showFooter = false

		if isLoggedIn
			defaultState = $state.get(ConfigurationService.getValue('Backoffice.Home.DefaultState')) ? {}
			defaultState.data ?= {}
			newState = false

			# Can not access default state because denied by config
			if toState.name == defaultState.name && ConfigurationService.isDisabled(toState.data.restrict)
				alert "User configuration error";
				newState = 'logout'

			# User already logged in but tries to access /login
			if toState.name == 'login' || toState.name == 'login.identifier'
				newState = defaultState.name

			# State is restricted by config
			if (
				(UserInformation.getSubUser()? && toState.data.restrictForUser) ||
				(toState.data.restrict && ConfigurationService.isDisabled(toState.data.restrict))
			)
				newState = defaultState.name

			if newState == defaultState.name
				$rootScope.hideMenu = defaultState.data.hideMenu ? false
				$rootScope.hideSubMenu = defaultState.data.hideSubMenu ? false
				$rootScope.showFooter = defaultState.data.showFooter ? true

		if newState
			return transition.router.stateService.target newState

	if AuthenticationService.isLoggedIn()
		MessageTerminal.publish(MessageTerminal.events.CSS_LOADED)
